import React, { memo, useEffect, useState } from "react"
import CardVod from "components/CardVod"
import Link from "next/link"
import DisplayTypeScreenBlock from "utils/DisplayTypeScreenBlock"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper"

// eslint-disable-next-line react/display-name
const MySwiper = memo(({ name, events, id, type_block, display_type, card_type }) => {
  const [deVice, setDeVice] = useState("desktop")
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 768) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    handleResize()

    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  useEffect(() => {
    if (window.innerWidth < 768) {
      setDeVice("mobile")
    } else if (window.innerWidth >= 768 && window.innerWidth < 980) {
      setDeVice("ipad")
    } else {
      setDeVice("desktop")
    }
  })

  return (
    <div className="flex flex-col">
      <Link href={`/danh-muc/${id}`}>
        <div className="w-full flex items-center wapper_see_more justify-between max-lg:mr-4 mr-8">
          <span className="max-sm:text-base max-sm:leading-[22px] text-xl font-semibold text-white">{name}</span>
          <div className={`flex items-center gap-[10px] text-primary text-xs sm:text-sm font-normal whitespace-nowrap`}>
            Xem thêm
          </div>
        </div>
      </Link>
      <div className="relative wapper__swiper__custom">
        <Swiper
          key="vod_item"
          slidesPerView={4}
          slidesPerGroup={4}
          spaceBetween={24}
          modules={[Navigation]}
          className={`${
            display_type === DisplayTypeScreenBlock.HORIZONTAL ? "swiper_card_horizontal" : "swiper_card_vertical"
          }`}
          navigation={true}
          breakpoints={{
            300: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "1.5" : "2.2"}` : "2.2"}`,
              slidesPerGroup: 1,
              spaceBetween: 12
            },
            430: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "1.8" : "2.5"}` : "2.5"}`,
              slidesPerGroup: 1,
              spaceBetween: 12
            },
            520: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "2.1" : "2.8"}` : "2.8"}`,
              slidesPerGroup: 1,
              spaceBetween: 12
            },
            600: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "2.3" : "3.2"}` : "3.2"}`,
              slidesPerGroup: 1,
              spaceBetween: 12
            },
            690: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "2.5" : "3.5"}` : "3.5"}`,
              slidesPerGroup: 1,
              spaceBetween: 12
            },
            768: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "2.2" : "2.5"}` : "3.4"}`,
              slidesPerGroup: 2
            },
            815: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "2.5" : "2.8"}` : "3.7"}`,
              slidesPerGroup: 2
            },
            875: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "2.7" : "3.1"}` : "4.1"}`,
              slidesPerGroup: 2
            },
            945: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "2.9" : "3.3"}` : "4.5"}`,
              slidesPerGroup: 3
            },
            1030: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "3.1" : "3.5"}` : "4.9"}`,
              slidesPerGroup: 3
            },
            1105: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "3.3" : "3.7"}` : "5.2"}`,
              slidesPerGroup: 3
            },
            1170: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "3.4" : "3.8"}` : "5.3"}`,
              slidesPerGroup: 3
            },
            1200: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "2.8" : "3.2"}` : "4.4"}`,
              slidesPerGroup: 3
            },
            1300: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "3.1" : "3.6"}` : "4.9"}`,
              slidesPerGroup: 3
            },
            1400: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "3.4" : "3.9"}` : "5.4"}`,
              slidesPerGroup: 3
            },
            1505: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "3.7" : "4.3"}` : "5.8"}`,
              slidesPerGroup: 3
            },
            1600: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "3.9" : "4.5"}` : "6.2"}`,
              slidesPerGroup: 3
            },
            1685: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "4.2" : "4.9"}` : "6.6"}`,
              slidesPerGroup: 3
            },
            1775: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "4.4" : "5.1"}` : "6.9"}`,
              slidesPerGroup: 3
            },
            1850: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "4.6" : "5.3"}` : "7.2"}`,
              slidesPerGroup: 3
            },
            2536: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "4.8" : "5.8"}` : "8.1"}`,
              slidesPerGroup: 4
            },
            2700: {
              slidesPerView: `${display_type === 0 ? `${card_type === 0 ? "5.1" : "6.4"}` : "8.9"}`,
              slidesPerGroup: 4
            }
          }}
        >
          {events?.length > 0 &&
            events?.map((item) => {
              return (
                <SwiperSlide key={item?.id}>
                  <CardVod {...item} display_type={display_type} showTime={false} />
                </SwiperSlide>
              )
            })}
        </Swiper>
      </div>
    </div>
  )
})

export default MySwiper
